<!-- 由 suu 创建于 2022-05-05 星期四 -->
<template>
  <div class="lisa-questionnaire">
    <ques-result v-if="result" :info="result"></ques-result>
    <template v-else>
      <!-- 进度 -->
      <ques-pro
        :cur="cur"
        v-if="list.length"
        :total="list.length"
        @on-last="handelLast"
      ></ques-pro>
      <!-- 问题列表 -->
      <template v-for="(item, index) in list">
        <div class="ques-item" :key="index" v-if="index === cur">
          <ques-radio-gender
            v-if="item.field == 'sex'"
            :info="item"
            @on-change="handelGenderChange"
          ></ques-radio-gender>
          <ques-checkbox
            :info="item"
            :gender="gender"
            v-if="item.field_type == 'checkbox'"
            @on-change="handelCheckboxChange"
          ></ques-checkbox>
          <template v-if="!['radio'].includes(item.field_type)">
            <div
              class="ques-next user-btn"
              :class="{ 'ques-next-off': !item.value || !item.value.length }"
              @click="handelNext"
            >
              {{ cur >= list.length - 1 ? '提交' : '下一题' }}
            </div>
            <div class="ques-tips">
              <span>*</span> 测试结果由每个选项综合计算得出，请务必准确填写
            </div>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import quesPro from './ponents/ques-pro.vue'
import quesRadioGender from './ponents/ques-radio-gender.vue'
import quesCheckbox from './ponents/ques-checkbox.vue'
import quesResult from './ponents/ques-result.vue'
export default {
  name: 'lisa-questionnaire',

  components: { quesPro, quesRadioGender, quesCheckbox, quesResult },

  props: {},

  data() {
    return {
      cur: 0, // 当前问题下标
      gender: '', // 选择的性别
      list: [], // 问卷列表
      result: null // 提交结果
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getList()
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 上一步
     */
    handelLast() {
      this.cur--
    },
    /**
     * 下一步
     */
    handelNext() {
      if (
        !this.list[this.cur]['value'] ||
        !this.list[this.cur]['value'].length
      ) {
        return
      }
      if (this.cur < this.list.length - 1) {
        this.cur++
      } else {
        // 提交
        this.submit()
      }
    },
    /**
     * 性别选择
     */
    handelGenderChange(value) {
      this.list[this.cur]['value'] = value
      this.gender = value
      setTimeout(() => {
        this.cur++
      }, 250)
    },
    /**
     * 多选选择
     */
    handelCheckboxChange(value) {
      this.list[this.cur]['value'] = value
    },
    /**
     * 提交问卷
     */
    submit() {
      let params = {
        info: JSON.stringify(this.list)
      }
      this.$http
        .postBaseApp('member/AppCamp/saveBodyQuestion', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('提交成功')
            this.result = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {})
        .finally(() => {})
    },
    /**
     * 获取问卷
     */
    getList() {
      let params = {}
      this.$http
        .getBaseApp('member/AppCamp/bodyquestion', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data['type']) {
              this.result = res.data
            } else {
              this.list = res.data[0].sub_list
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {})
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.lisa-questionnaire {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f7f7f7;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include paddingBottom(39px);
  .ques-item {
    width: 343px;
    min-height: 623px;
    box-sizing: border-box;
    padding: vw(36) vw(26);
    background: #ffffff;
    border-radius: 12px;
    // overflow-y: auto;
    .ques-next {
      width: 211px;
      height: 44px;
      border-radius: 22px;
      background: #524485;
      color: #fff;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-top: 60px;
    }
    .ques-next-off {
      background: rgba($color: #524485, $alpha: 0.36);
    }
    .ques-tips {
      font-size: 11px;
      font-weight: 400;
      color: #262f44;
      margin-top: 16px;
      text-align: center;
      span {
        color: #ff5577;
      }
    }
  }
}
</style>
